import { CUSTOMER_REPRESENTATIVE } from '../constants';

export const getStepPath = (pathname) =>
  `/${pathname
    .split('/')
    .filter(Boolean)
    .pop()}`;

export const getSteps = (pathname, representative) => {
  const flow = representative === CUSTOMER_REPRESENTATIVE.SOMEONE_ELSE ? 'representative' : 'myself';

  const configuredSteps = JOURNEY_STEPS[flow];

  const currentIndex = getCurrentStepIndex(pathname, representative);

  if (currentIndex === -1) {
    return null;
  }

  const maxCompletedStep = getMaxCompletedStep();

  return configuredSteps.map((step, index) => ({
    title: step.title,
    status: index === currentIndex ? 'current' : index < maxCompletedStep ? 'completed' : 'not started',
    active: index === currentIndex,
  }));
};

const JOURNEY_STEPS = {
  myself: [
    {
      title: 'Personal details',
      paths: ['/customer-details'],
    },
    {
      title: 'Service required',
      paths: ['/services-required', '/codeword', '/nominee-details'],
    },
    {
      title: 'Reason required',
      paths: ['/reasons-required', '/your-language', '/life-changes-dates', '/hospital-dates', '/young-adult-dates'],
    },
    {
      title: 'Summary',
      paths: ['/your-summary'],
    },
  ],

  representative: [
    {
      title: "Customer's details",
      paths: ['/customer-details'],
    },
    {
      title: 'Your details',
      paths: ['/3rd-party-details'],
    },
    {
      title: 'Service required',
      paths: ['/services-required', '/codeword', '/nominee-details'],
    },
    {
      title: 'Reason required',
      paths: ['/reasons-required', '/your-language', '/life-changes-dates', '/hospital-dates', '/young-adult-dates'],
    },
    {
      title: 'Summary',
      paths: ['/your-summary'],
    },
  ],
};

export const getStepTitle = (stepTitle, representative) => {
  const steps =
    representative === CUSTOMER_REPRESENTATIVE.SOMEONE_ELSE ? JOURNEY_STEPS.representative : JOURNEY_STEPS.myself;

  const stepNumber = steps.findIndex((step) => step.title === stepTitle) + 1;

  return `${stepNumber}. ${stepTitle}`;
};

export const getCurrentStepIndex = (pathname, representative) => {
  const flow = representative === CUSTOMER_REPRESENTATIVE.SOMEONE_ELSE ? 'representative' : 'myself';

  const configuredSteps = JOURNEY_STEPS[flow];

  const routeName = getStepPath(pathname);

  return configuredSteps.findIndex((step) => step.paths.includes(routeName));
};

const MAX_COMPLETED_STEP_KEY = 'maxCompletedStep';

export const getMaxCompletedStep = () => Number(sessionStorage.getItem(MAX_COMPLETED_STEP_KEY)) || 0;

export const setMaxCompletedStep = (step) => {
  const current = getMaxCompletedStep();

  sessionStorage.setItem(MAX_COMPLETED_STEP_KEY, Math.max(current, step));
};

export const clearMaxCompletedStep = () => {
  sessionStorage.removeItem(MAX_COMPLETED_STEP_KEY);
};
